import React from 'react';
import { ThemeListProvider } from './themeList';
import { CommitteeListProvider } from './committeeList';
import { SlotListProvider } from './slotList';
import { MeetListProvider } from './meetList';
import { MinuteListProvider } from './minuteList';
import { ActionListProvider } from './actionList';
import { DeliberationListProvider } from './deliberationList';
import { ProfileManagementListProvider } from './profileManagementList';
import { FileListProvider } from './fileList';

const ListsContexts = ({children}) => (
  <ThemeListProvider>
    <CommitteeListProvider>
      <SlotListProvider>
        <MeetListProvider>
          <MinuteListProvider>
            <ActionListProvider>
              <DeliberationListProvider>
                <ProfileManagementListProvider>
                  <FileListProvider>
                    {children}
                  </FileListProvider>
                </ProfileManagementListProvider>
              </DeliberationListProvider>
            </ActionListProvider>
          </MinuteListProvider>
        </MeetListProvider>
      </SlotListProvider>
    </CommitteeListProvider>
  </ThemeListProvider>
);

export default ListsContexts;